var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1635 14.1219C14.4976 15.2448 13.2041 15.8356 11.9194 15.6039C10.6347 15.3722 9.62916 14.3667 9.39745 13.082C9.16574 11.7973 9.75664 10.5038 10.8795 9.83789",
    stroke: "#1D1E14",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7438 17.7022C16.9479 19.0644 14.7541 19.7986 12.5 19.7917C8.76498 19.8582 5.31396 17.8055 3.58957 14.4917C2.97014 13.2362 2.97014 11.7639 3.58957 10.5084C4.45197 8.791 5.82671 7.38402 7.52365 6.48206",
    stroke: "#1D1E14",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2748 14.7225C21.3167 14.6434 21.371 14.5724 21.4105 14.4917C22.0299 13.2361 22.0299 11.7639 21.4105 10.5083C19.6861 7.19454 16.2351 5.14184 12.5001 5.20836C12.2659 5.20836 12.0383 5.23961 11.8071 5.25484",
    stroke: "#1D1E14",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8751 20.8333L4.16675 3.125",
    stroke: "#1D1E14",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.b87674750ba3e5e1c51566afbd4615f6.svg";
export { ForwardRef as ReactComponent };